import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

export type TicketHeaderControls = {
  bookmarked: boolean
  bookmarkBusy: boolean
  onBookmarkClick: () => void
  onCopyLink: () => void
}

type TicketHeaderContextValue = {
  controls: TicketHeaderControls | null
  setControls: (v: TicketHeaderControls | null) => void
}

const TicketHeaderContext = createContext<TicketHeaderContextValue | null>(null)

export function TicketHeaderProvider({ children }: { children: ReactNode }) {
  const [controls, setControls] = useState<TicketHeaderControls | null>(null)
  const value = useMemo(() => ({ controls, setControls }), [controls])
  return <TicketHeaderContext.Provider value={value}>{children}</TicketHeaderContext.Provider>
}

export function useTicketHeader() {
  return useContext(TicketHeaderContext)
}
